import { render, staticRenderFns } from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=template&id=4d993be6&scoped=true"
import script from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=script&lang=js"
export * from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=style&index=0&id=4d993be6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d993be6",
  null
  
)

export default component.exports